import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const PlaybackRateSelector = ({ currentRate, onChange, iconStyles }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (rate) => {
    onChange(rate);
    handleClose();
  };

  return (
    <div>
      <Button aria-controls="playback-rate-menu" aria-haspopup="true" onClick={handleClick} style={iconStyles}>
        {currentRate}x
      </Button>
      <Menu
        id="playback-rate-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <MenuItem onClick={() => handleSelect(0.5)}>0.5x</MenuItem>
        <MenuItem onClick={() => handleSelect(0.75)}>0.75x</MenuItem>
        <MenuItem onClick={() => handleSelect(1.0)}>Normal</MenuItem>
        <MenuItem onClick={() => handleSelect(1.25)}>1.25x</MenuItem>
        <MenuItem onClick={() => handleSelect(1.5)}>1.5x</MenuItem>
        <MenuItem onClick={() => handleSelect(2.0)}>2x</MenuItem>
      </Menu>
    </div>
  );
};

export default PlaybackRateSelector;
